var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SingularityCanvasButton',{attrs:{"icon":"EditSolidIcon","text":`Edit ${_vm.elementTitle}`},on:{"click":_vm.editElement}})
}
var staticRenderFns = []

export { render, staticRenderFns }